/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RadiationType = {
    Photon: 'Photon',
    Electron: 'Electron',
    Neutron: 'Neutron',
    Proton: 'Proton'
} as const;
export type RadiationType = typeof RadiationType[keyof typeof RadiationType];


export function RadiationTypeFromJSON(json: any): RadiationType {
    return RadiationTypeFromJSONTyped(json, false);
}

export function RadiationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RadiationType {
    return json as RadiationType;
}

export function RadiationTypeToJSON(value?: RadiationType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the RadiationType interface.
 */
 export function instanceOfRadiationType(value: any): value is RadiationType {
    return Object.values(RadiationType).includes(value)
}

